export const placeInFirst = <T,>(array: T[], predicate: (item: T) => boolean) => {
  if (!array) return array;
  const index = array.findIndex(predicate);
  if (index === -1) return array;
  const item = array[index];
  return [item, ...array.filter((_, i) => i !== index)];
};